/**
 * Converts a slug (e.g. 'table-games') into a human-readable title (e.g. 'Table Games').
 * Useful for displaying route segments or game types in a user-friendly format.
 *
 * Example:
 * slugToTitle('table-games') -> 'Table Games'
 */
export const slugToTitle = (slug: string): string => {
  return slug
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
